import { render } from "./PrincipalLobbyClientComponent.vue?vue&type=template&id=3a3bf1a6&scoped=true"
import script from "./PrincipalLobbyClientComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalLobbyClientComponent.vue?vue&type=script&lang=js"

import "./PrincipalLobbyClientComponent.vue?vue&type=style&index=0&id=3a3bf1a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3bf1a6"]])

export default __exports__